import { render, staticRenderFns } from "./calendarEmployer.vue?vue&type=template&id=050bef4a"
import script from "./calendarEmployer.vue?vue&type=script&lang=js"
export * from "./calendarEmployer.vue?vue&type=script&lang=js"
import style0 from "./calendarEmployer.vue?vue&type=style&index=0&id=050bef4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports